(function () {
  'use strict';

  function initDesktopScroll(section) {
    var features = Array.from(section.querySelectorAll('.iws__feature'));
    var images = Array.from(section.querySelectorAll('.iws__image-item'));
    if (!features.length || !images.length) return;

    var activeIndex = 0;

    function setActive(index) {
      if (index === activeIndex && features[index].classList.contains('iws__feature--active')) return;
      activeIndex = index;
      features.forEach(function (f) { f.classList.remove('iws__feature--active'); });
      images.forEach(function (img) { img.classList.remove('iws__image-item--active'); });
      if (features[index]) features[index].classList.add('iws__feature--active');
      if (images[index]) images[index].classList.add('iws__image-item--active');
    }

    function getClosestIndex() {
      var viewportCenter = window.innerHeight * 0.45;
      var closest = 0;
      var closestDist = Infinity;
      features.forEach(function (f, i) {
        var rect = f.getBoundingClientRect();
        var featureCenter = (rect.top + rect.bottom) / 2;
        var dist = Math.abs(featureCenter - viewportCenter);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          setActive(getClosestIndex());
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    setActive(0);
  }

  function initMobileSwiper(section) {
    var swiperEl = section.querySelector('.iws__mobile-swiper');
    var paginationEl = section.querySelector('.iws__mobile-pagination');
    if (!swiperEl) return;
    if (typeof Swiper === 'undefined') return;

    var hint = section.querySelector('.iws__swipe-hint');

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 1.05,
      spaceBetween: 8,
      grabCursor: true,
      pagination: {
        el: paginationEl,
        clickable: true
      },
      on: {
        slideChange: function () {
          
          if (hint) {
            var isLast = this.activeIndex >= this.slides.length - 1;
            console.log('hello',hint)
            if (isLast) {
              hint.classList.add('iws__swipe-hint--hidden');
            } else {
              hint.classList.remove('iws__swipe-hint--hidden');
            }
          }
        }
      }
    });

    if (hint) {
      hint.addEventListener('click', function () {
        swiper.slideNext();
      });
    }
  }

  function init() {
    document.querySelectorAll('.iws').forEach(function (section) {
      if (window.innerWidth >= 750) {
        initDesktopScroll(section);
      } else {
        initMobileSwiper(section);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.iws');
    if (!section) return;
    if (window.innerWidth >= 750) {
      initDesktopScroll(section);
    } else {
      initMobileSwiper(section);
    }
  });
})();
